import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDropdown = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 11.195,
	height: 7.16,
	fill: "currentColor",
	viewBox: "0 0 11.195 7.16",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		id: "Path_7447",
		"data-name": "Path 7447",
		d: "M8.876,12.666,12.914,16.7a1.553,1.553,0,0,0,2.2,0l4.038-4.038A1.564,1.564,0,0,0,18.043,10H9.967A1.559,1.559,0,0,0,8.876,12.666Z",
		transform: "translate(-8.414 -10)"
	})
});
export { SvgDropdown as ReactComponent };
